export const truffles = [
  {
    id: "magnatum",
    name: "Magnatum Pico",
    sub: { it: "Tartufo Bianco", en: "White Truffle" },
    image: "/img/MagnatumPico.png",
    description: {
      it: "Il Tartufo Bianco, conosciuto anche come Tuber Magnatum Pico, è considerato il re dei tartufi grazie alla sua rarità e al suo sapore distintivo.",
      en: "The White Truffle, also known as Tuber Magnatum Pico, is considered the king of truffles due to its rarity and distinctive flavor.",
    },
  },
  {
    id: "scorzone",
    name: "Nero Estivo",
    sub: { it: "Scorzone", en: "Summer Black · Scorzone" },
    image: "/img/NeroScorzone.png",
    description: {
      it: "Il Tartufo Nero Estivo ha un sapore delicato con note di nocciola. È ampiamente disponibile durante l'estate e usato per arricchire piatti senza sopraffare gli altri sapori.",
      en: "The Summer Black Truffle has a delicate flavor with hints of hazelnut. It is widely available during the summer and used to enrich dishes without overpowering other flavors.",
    },
  },
  {
    id: "pregiato",
    name: "Nero Pregiato",
    sub: { it: "Melanosporum Vitt.", en: "Melanosporum Vitt." },
    image: "/img/NeroPregiato.png",
    description: {
      it: "Con un aroma complesso e terroso, il Tartufo Nero Pregiato è raccolto in inverno e molto apprezzato nella cucina gourmet.",
      en: "With a complex and earthy aroma, the Precious Black Truffle is harvested in winter and highly valued in gourmet cuisine.",
    },
  },
  {
    id: "brumale",
    name: "Nero Invernale",
    sub: { it: "Brumale", en: "Winter Black · Brumale" },
    image: "/img/neroInvernaleBrumale.png",
    description: {
      it: "Simile al Nero Pregiato, ma con un aroma meno intenso, questo tartufo è raccolto in inverno e usato come alternativa più economica nei piatti invernali.",
      en: "Similar to the Precious Black Truffle, but with a less intense aroma, this truffle is harvested in winter and used as a more economical alternative in winter dishes.",
    },
  },
];
